/**
 * GPT-Live has no session-configuration, commit, cancel or truncate client
 * events: the session object is fixed at `session.start` and barge-in is
 * handled upstream. The backend drops these frames, and the Live client must
 * not put them on the wire in the first place.
 */
const LIVE_BLOCKED_CLIENT_EVENTS = new Set([
  "session.update",
  "input_audio_buffer.commit",
  "response.cancel",
  "conversation.item.truncate",
])

/** True when GPT-Live has no equivalent for this client event. */
export function isLiveBlockedClientEvent(eventType: string): boolean {
  return LIVE_BLOCKED_CLIENT_EVENTS.has(eventType)
}

type LiveStartFrame = {
  type: "live.start"
  voice: string
  voice_internal_data_consent?: true
  route_id?: string
  session_type?: string
  session_id?: string
}

/**
 * First frame on `/api/ws/live`. The backend owns the model, instructions and
 * delegation, so the client contributes only the voice, the routing context and
 * the consent marker — mirroring `buildRealtimeSessionUpdate`.
 */
export function buildLiveStartFrame(
  voice: string,
  hasInternalDataConsent: boolean,
  routing: { routeId?: string; sessionType?: string; sessionId?: string } = {}
): LiveStartFrame {
  return {
    type: "live.start",
    voice,
    ...(hasInternalDataConsent ? { voice_internal_data_consent: true as const } : {}),
    ...(routing.routeId ? { route_id: routing.routeId } : {}),
    ...(routing.sessionType ? { session_type: routing.sessionType } : {}),
    ...(routing.sessionId ? { session_id: routing.sessionId } : {}),
  }
}
